module.exports = "fragment CampaignShareFragment on CampaignShare {\n  __typename\n  id\n  fromName\n  dateShared\n  campaign {\n    name\n  }\n}\n"